import { render, staticRenderFns } from "./detailActionPostMortem.vue?vue&type=template&id=6b1b2dd8&scoped=true"
import script from "./detailActionPostMortem.vue?vue&type=script&lang=js"
export * from "./detailActionPostMortem.vue?vue&type=script&lang=js"
import style0 from "./detailActionPostMortem.vue?vue&type=style&index=0&id=6b1b2dd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1b2dd8",
  null
  
)

export default component.exports